import React from 'react';

import Controls from './Controls';
import LiveVideo from './LiveVideo';

type HomeProps = {
  session: any;
};

const Home = ({ session }: HomeProps) => {
  return (
    <div
      style={{
        backgroundColor: 'black',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
      }}
    >
      <p style={{ color: '#999', fontSize: '14px', margin: '10px 0' }}>
        Warning: Video feed has a 5+ second delay
      </p>
      <LiveVideo />

      <div style={{ marginTop: '20px' }}>
        <Controls session={session} />
      </div>
    </div>
  );
};

export default Home;
